import { Component } from "@angular/core";

@Component({
    selector: "app-about-us-page",
    templateUrl: "./about-us-page.component.html",
    styleUrls: ["./about-us-page.component.scss"],
    standalone: false
})
export class AboutUsPageComponent {}